const layoutBoxes = {
  large: { // 480
    regular: [30, 110, 306, 30],
    halfSplitLargeRight: [30, 110, 100, 106, 100, 30],
    halfSplitRegularRight: [30, 110, 111, 84, 111, 30],
    halfSplitSmallRight: [30, 110, 142, 58, 106, 30],
    portOfLoading: [30, 146, 106, 58, 106, 30],
    break: 0,
  },
  break1: { // 420
    regular: [25, 110, 256, 25],
    halfSplitLargeRight: [25, 110, 75, 106, 75, 25],
    halfSplitRegularRight: [25, 110, 86, 84, 86, 25],
    halfSplitSmallRight: [25, 110, 117, 58, 81, 25],
    portOfLoading: [25, 146, 81, 58, 81, 25],
    break: 1,
  },
  break2: { // 360
    regular: [15, 110, 216, 15],
    halfSplitLargeRight: [15, 110, 55, 106, 55, 15],
    halfSplitRegularRight: [15, 110, 66, 84, 66, 15],
    halfSplitSmallRight: [15, 110, 97, 58, 61, 15],
    portOfLoading: [15, 146, 61, 58, 61, 15],
    break: 2,
  },
  break3: { // 340
    regular: [10, 110, 206, 10],
    halfSplitLargeRight: [10, 110, 50, 106, 50, 10],
    halfSplitRegularRight: [10, 110, 61, 84, 61, 10],
    halfSplitSmallRight: [10, 110, 92, 58, 56, 10],
    portOfLoading: [10, 146, 56, 58, 56, 10],
    break: 3,
  },
  break4: {
    regular: [10, 110, 186, 10],
    halfSplitLargeRight: [10, 110, 40, 105, 40, 10],
    halfSplitRegularRight: [10, 110, 51, 84, 51, 10],
    halfSplitSmallRight: [10, 110, 82, 58, 46, 10],
    portOfLoading: [10, 146, 46, 58, 46, 10],
    break: 4,
  }
};

interface IndexByString {
  [key: string]: string,
};

const operations: IndexByString = {
  home: 'Home',
  oceanImport: 'Ocean Import',
  oceanExport: 'Ocean Export',
  airImport: 'Air Import',
  airExport: 'Air Export',
  otherShipment: 'Other Shipment',
  whReceipt: 'Freight Receipt', //Change name W/H Receipt -> Freight Receipt
  warehousing: 'Warehouse',     //Change name Warehousing -> Warehouse
  opReport: 'OP Manager Report',  
  accounting: 'Accounting',
  customer: 'Customer List',
  utility: 'Util',
  billings: 'Billings',
  myEvent: 'My Event',
  businessIntell: 'Business Intelligence',
  ams: 'AMS/ACI',
  isf: 'ISF',
  aes: 'AES',

  // Special 'virtual' operation, used for screens that are not common to all regular operations,
  // but appear standalone in Job Menu, but in the other way behave as other screens in regular operations
  standalone: 'Standalone',
  myTask: 'My Task',
  shipmentStatus: 'Shipment Control Tower',
  //reportManager: 'OP Report',
  cntr: 'Container List',
  aiCenter: 'AI Center',
}

const types: IndexByString = {
  MBL: 'MBL',
  HBL: 'HBL',
  MAWB: 'MAWB',
  HAWB: 'HAWB',
  OEBook : 'BK',
  OtherOP : '',
  WHRcv : 'RCV',
  WHShip : 'SHP',
  Company : '',
  AMS:'AMS',
  ISF: 'ISF',
  AES: 'AES',
}

const constants = {
  opTypes: {
    home: 'home',
    oceanImport: 'oceanImport',
    oceanExport: 'oceanExport',
    airImport: 'airImport',
    airExport: 'airExport',
    otherShipment: 'otherShipment',
    whReceipt: 'freightReceipt', //Change name W/H Receipt -> Freight Receipt
    warehousing: 'warehousing',    
    opReport:'opReport',
    accounting: 'accounting',
    customer: 'customer',
    standalone: 'standalone',
   // reportManager: 'reportManager',
    utility: 'utility',
    billings: 'billings',
    myEvent: 'myEvent',
    businessIntell: 'businessIntell',
    ams:'ams',
    isf:'isf',
    aes:'aes',
    myTask: 'myTask',
    shipmentStatus: 'shipmentStatus',
    cntr: 'containerList',
    aiCenter: 'aiCenter',
  },
  operations,
  types,
  layout: layoutBoxes,
  infoAreaEntity: {
    oceanImportMbl: 'T_OIMMAIN',
    oceanImportHbl: 'T_OIHMAIN',
    oceanExportMbl: 'T_OOMMAIN',
    oceanExportHbl: 'T_OOHMAIN',
    oceanImportInvoice: 'T_INVOHD',
    oceanImportBill: 'T_APHD',
    oceanImportCrdb: 'T_CRDBHD',
    oceanImportQuotation: 'T_OOHQUOTATION',
    codeMiscMemoTitle: 'T_CODECARGOSTATUS',
    codeCompanyBranch: 'T_CODEBRANCH',
    codeCompanyCompany: 'T_COMPANY',
    codeCompanyCompanyUser: 'T_USER',
    codeCompanyDepartment: 'T_DEPARTMENT',
    codeOceanPortCode: 'T_CODEOCEANPORT',
    codeOceanVesselName: 'T_CODEVESSEL',
    codeMiscCommodity: 'T_CODECOMMODITY',
  },
  SAVE_SUCCESS_DEFAULT_MSG: 'Successfully saved',
  SAVE_ERROR_MESSAGE: 'Save failure',
  LOAD_ERROR_MESSAGE: 'Cannot load data',

  BL_INFO: 'B/L Info',
  Doc_Server: 'Doc. Server',
  Document_Server: 'Document Server',
  List_Billings: 'Billings',
  List_Journal: 'Journal',
};

export const Units = [
  'BAGS', 'BALES', 'BDLS', 'CARTONS', 'CASES', 'CRATES', 'CTNS', 'DRUMS', 'GOH',
  'L/VANS', 'P/E', 'PCS', 'PALLETS', 'PIECES', 'PKGS', 'ROLLS', 'W/CRTS', 'W/CS'
];

export default constants;
  